import { PageHelp } from '@/components/ui/PageHelp';
import { useEffect } from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { Bell, CalendarClock } from 'lucide-react';
import { useMyNotifications, useMarkNotificationsRead } from '@/api/resources';

export default function MyHistoryPage() {
  const { data, isLoading } = useMyNotifications();
  const markRead = useMarkNotificationsRead();
  const notifications = data?.notifications ?? [];
  const unreadCount = data?.unreadCount ?? 0;

  // En consultant l'historique, on marque tout comme lu.
  useEffect(() => {
    if (unreadCount > 0) markRead.mutate(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unreadCount]);

  return (
    <div className="space-y-5">
      <div>
        <div className="text-[11px] uppercase tracking-[0.15em] text-slate-500 font-medium mb-1">
          Historique
        </div>
        <h2 className="text-[26px] font-semibold tracking-tight leading-tight">
          Mes notifications <PageHelp topic="myHistory" />
        </h2>
        <p className="text-[12.5px] text-slate-500 mt-1">
          Toutes les modifications qui concernent votre emploi du temps.
        </p>
      </div>

      {isLoading && <div className="text-[12px] text-slate-500">Chargement…</div>}

      {!isLoading && notifications.length === 0 && (
        <div className="rounded-lg border border-slate-200 bg-white p-8 text-center">
          <Bell size={22} className="text-slate-300 mx-auto mb-2" />
          <div className="text-[13px] text-slate-500">Aucune notification pour le moment.</div>
        </div>
      )}

      <div className="space-y-2">
        {notifications.map((n) => (
          <div
            key={n.id}
            className={`rounded-lg border p-3.5 flex items-start gap-3 ${
              n.read ? 'border-slate-200 bg-white' : 'border-accent/30 bg-accent/5'
            }`}
          >
            <div
              className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${
                n.read ? 'bg-slate-100' : 'bg-accent/15'
              }`}
            >
              <CalendarClock size={14} className={n.read ? 'text-slate-400' : 'text-accent'} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <div className="text-[12.5px] font-semibold text-slate-900">{n.title}</div>
                {!n.read && <span className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />}
              </div>
              <div className="text-[12px] text-slate-600 mt-0.5">{n.message}</div>
              <div className="text-[10.5px] text-slate-400 mt-1.5">
                {format(new Date(n.createdAt), "EEEE d MMMM yyyy 'à' HH'h'mm", { locale: fr })}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
